import { i18n } from '@/plugins/i18n'

export const IvrSettlementVariant = {
    MANUAL_SETTLEMENT: 1,
    CHARGE_WALLET: 2,
};

export const IvrSettlementVariantStr = {
    MANUAL_SETTLEMENT: i18n.t('ivr.settlement_variant.manual_settlement'),
    CHARGE_WALLET: i18n.t('ivr.settlement_variant.charge_wallet'),

    get(variant) {
        let variant_str = null;

        Object.keys(IvrSettlementVariant).forEach(item => {
            if(IvrSettlementVariant[item] === variant) {
                variant_str = IvrSettlementVariantStr[item];
            }
        });

        return variant_str;
    }
};
